import dynamic from 'next/dynamic';

import { useDucatClient } from '@/context/DucatClientCtx';
import { canPerformVaultActions } from '@/lib/wallet-policy';

const ConnectedStatusBox = dynamic(() => import('./ConnectedStatusBox'));

const StatusBox = () => {
  const { isConnected, walletType } = useDucatClient();
  if (!isConnected || !canPerformVaultActions(walletType)) return null;
  return <ConnectedStatusBox />;
};

export default StatusBox;
